(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function init(el) {
      if (!el || el.getAttribute('data-ready')) return;

      var type = el.getAttribute('data-timer-type') || 'manual';
      var start = parseInt(el.getAttribute('data-start'), 10) || 0;
      var end = parseInt(el.getAttribute('data-end'), 10) || 0;
      var hoursEl = el.querySelector('[data-cdb-hours]');
      var minutesEl = el.querySelector('[data-cdb-minutes]');
      var secondsEl = el.querySelector('[data-cdb-seconds]');
      var behavior = el.getAttribute('data-expired-behavior');
      var isDesignMode = !!(window.Shopify && window.Shopify.designMode);
      var timer = null;

      /* Fixed mode: personal countdown per visitor, restarts on every load/refresh */
      if (type === 'fixed') {
        var duration = parseInt(el.getAttribute('data-duration'), 10) || 0;
        start = 0;
        end = duration > 0 ? Math.floor(Date.now() / 1000) + duration : 0;
      }

      if (!end) {
        el.setAttribute('data-state', 'invalid');
        el.setAttribute('data-ready', 'true');
        if (isDesignMode && window.console) {
          console.warn('Countdown bar: check the timer settings (fixed minutes, or end date, time and timezone format YYYY-MM-DD, HH:MM:SS, -04:00).');
        }
        return;
      }

      function setText(node, value) {
        if (node && node.textContent !== value) node.textContent = value;
      }

      function setState(state) {
        if (el.getAttribute('data-state') !== state) {
          el.setAttribute('data-state', state);
        }
        var shouldHide =
          !isDesignMode && (state === 'upcoming' || (state === 'expired' && behavior === 'hide'));
        if (el.hidden !== shouldHide) el.hidden = shouldHide;
      }

      function render() {
        if (!el.isConnected) {
          clearInterval(timer);
          return;
        }
        var now = Math.floor(Date.now() / 1000);
        var diff = Math.max(0, end - now);

        setText(hoursEl, pad(Math.floor(diff / 3600)));
        setText(minutesEl, pad(Math.floor((diff % 3600) / 60)));
        setText(secondsEl, pad(diff % 60));

        if (start && now < start) {
          setState('upcoming');
        } else if (now >= end) {
          setState('expired');
          clearInterval(timer);
        } else {
          setState('active');
        }
      }

      render();
      el.setAttribute('data-ready', 'true');
      if (el.getAttribute('data-state') !== 'expired') {
        timer = setInterval(render, 500);
        document.addEventListener('visibilitychange', function () {
          if (!document.hidden) render();
        });
      }
    }

    function initAll(root) {
      var scope = root || document;
      var bars = scope.querySelectorAll('[data-countdown-bar]');
      for (var i = 0; i < bars.length; i++) init(bars[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hk-faq')) {
    class HkFaq extends HTMLElement {
      connectedCallback() {
        this.multiple = this.dataset.multiple === 'true';
        this.items = Array.from(this.querySelectorAll('[data-hk-faq-item]'));

        this.items.forEach((item) => {
          const trigger = item.querySelector('[data-hk-faq-trigger]');
          if (!trigger) return;
          trigger.addEventListener('click', () => this.toggle(item));
        });

        this.onBlockSelect = (e) => {
          const item = this.items.find((it) => {
            const t = it.querySelector('[data-hk-faq-trigger]');
            return t && t.dataset.blockId === e.detail.blockId;
          });
          if (item && !item.classList.contains('is-open')) this.toggle(item);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      setState(item, open) {
        const trigger = item.querySelector('[data-hk-faq-trigger]');
        item.classList.toggle('is-open', open);
        if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      toggle(item) {
        const willOpen = !item.classList.contains('is-open');
        if (willOpen && !this.multiple) {
          this.items.forEach((other) => {
            if (other !== item) this.setState(other, false);
          });
        }
        this.setState(item, willOpen);
      }
    }
    customElements.define('hk-faq', HkFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-main-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hk-product')) return;

  const formatMoney = (cents, format) => {
    const value = Number(cents) || 0;
    const fmt = format || '$' + '{' + '{amount}}';
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const withDelimiters = (num, precision = 2, thousands = ',', decimal = '.') => {
      const fixed = (num / 100).toFixed(precision);
      const [whole, frac] = fixed.split('.');
      const dollars = whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      return frac ? dollars + decimal + frac : dollars;
    };
    const match = fmt.match(placeholder);
    if (!match) return fmt;
    let out;
    switch (match[1]) {
      case 'amount_no_decimals': out = withDelimiters(value, 0); break;
      case 'amount_with_comma_separator': out = withDelimiters(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = withDelimiters(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = withDelimiters(value, 2, "'", '.'); break;
      case 'amount_with_space_separator': out = withDelimiters(value, 2, ' ', ','); break;
      default: out = withDelimiters(value, 2);
    }
    return fmt.replace(placeholder, out).replace(/<[^>]*>/g, '');
  };

  class HkProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      const json = this.querySelector('[data-hk-json]');
      if (!json) return;
      this._ready = true;

      this.data = JSON.parse(json.textContent);
      this.variants = this.data.variants || [];
      this.variant = this.variants.find((v) => String(v.id) === this.dataset.variant) || this.variants[0] || null;
      this.mode = this.dataset.mode || 'onetime';
      this.planId = this.dataset.plan || null;

      this.initGallery();
      this.initVariants();
      this.initPurchase();
      this.initQuantity();
      this.initForm();
      this.render();

      if (this.variant && this.variant.featured_media_id && this.dataset.mediaSwitch === 'true') {
        requestAnimationFrame(() => this.goToMedia(this.variant.featured_media_id, false));
      }
    }

    money(cents) {
      return formatMoney(cents, this.data.moneyFormat);
    }

    /* ---------------- Gallery ---------------- */
    initGallery() {
      this.track = this.querySelector('[data-hk-track]');
      if (!this.track) return;
      this.slides = [...this.querySelectorAll('[data-hk-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-hk-thumb]')];
      this.dots = [...this.querySelectorAll('[data-hk-dot]')];
      this.thumbsWrap = this.querySelector('[data-hk-thumbs]');
      this.index = 0;

      this.querySelector('[data-hk-prev]')?.addEventListener('click', () => this.goTo(this.index - 1));
      this.querySelector('[data-hk-next]')?.addEventListener('click', () => this.goTo(this.index + 1));
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(Number(t.dataset.index))));
      this.dots.forEach((d) => d.addEventListener('click', () => this.goTo(Number(d.dataset.index))));

      let frame;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const width = this.track.clientWidth || 1;
          const i = Math.round(this.track.scrollLeft / width);
          if (i !== this.index && this.slides[i]) {
            this.index = i;
            this.setActiveMedia();
          }
        });
      }, { passive: true });

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.goTo(this.index, false), 150);
      });
    }

    goTo(i, smooth = true) {
      if (!this.slides || !this.slides.length) return;
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      this.track.scrollTo({ left: this.slides[this.index].offsetLeft, behavior: smooth ? 'smooth' : 'instant' });
      this.setActiveMedia();
    }

    goToMedia(mediaId, smooth = true) {
      if (!this.slides) return;
      const i = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i > -1) this.goTo(i, smooth);
    }

    setActiveMedia() {
      this.thumbs.forEach((t, i) => t.classList.toggle('is-active', i === this.index));
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.index));
      this.slides.forEach((s, i) => {
        if (i !== this.index) s.querySelectorAll('video').forEach((v) => v.pause());
      });

      const thumb = this.thumbs[this.index];
      const wrap = this.thumbsWrap;
      if (!thumb || !wrap) return;
      if (getComputedStyle(wrap).flexDirection === 'column') {
        wrap.scrollTo({ top: thumb.offsetTop - wrap.clientHeight / 2 + thumb.offsetHeight / 2, behavior: 'smooth' });
      } else {
        wrap.scrollTo({ left: thumb.offsetLeft - wrap.clientWidth / 2 + thumb.offsetWidth / 2, behavior: 'smooth' });
      }
    }

    /* ---------------- Variants ---------------- */
    initVariants() {
      this.querySelectorAll('[data-hk-variant-card]').forEach((input) => {
        input.addEventListener('change', () => {
          const v = this.variants.find((x) => String(x.id) === input.value);
          if (v) this.setVariant(v);
        });
      });

      this.optionSets = [...this.querySelectorAll('[data-hk-option]')];
      this.optionSets.forEach((set) => set.addEventListener('change', () => this.onOptionChange()));
    }

    getSelectedOptions() {
      return this.optionSets.map((set) => {
        const select = set.querySelector('select');
        if (select) return select.value;
        const checked = set.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    onOptionChange() {
      const values = this.getSelectedOptions();
      this.optionSets.forEach((set, i) => {
        const label = set.querySelector('[data-hk-option-value]');
        if (label) label.textContent = values[i] || '';
        set.querySelectorAll('.hk-pill').forEach((pill) => {
          const input = pill.querySelector('input');
          pill.classList.toggle('is-selected', !!input && input.checked);
        });
      });
      const match = this.variants.find((v) => v.options.every((opt, i) => opt === values[i]));
      this.setVariant(match || null);
    }

    setVariant(variant) {
      this.variant = variant;
      this.render();
      if (!variant) return;

      if (this.dataset.mediaSwitch === 'true' && variant.featured_media_id) {
        this.goToMedia(variant.featured_media_id);
      }
      if (this.dataset.updateUrl === 'true') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      this.dispatchEvent(new CustomEvent('hk:variant-change', {
        bubbles: true,
        detail: { variant, sectionId: this.dataset.section }
      }));
    }

    /* ---------------- Subscription ---------------- */
    initPurchase() {
      this.querySelectorAll('[data-hk-po]').forEach((card) => {
        const input = card.querySelector('[data-hk-po-input]');
        if (!input) return;
        card.addEventListener('click', (e) => {
          if (e.target.closest('select')) return;
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        input.addEventListener('change', () => {
          if (!input.checked) return;
          this.mode = input.value;
          this.render();
        });
      });

      const planSelect = this.querySelector('[data-hk-plan-select]');
      if (planSelect) {
        planSelect.addEventListener('change', () => {
          this.planId = planSelect.value;
          this.render();
        });
      }
    }

    getAllocation(variant) {
      if (!variant || !this.planId || !variant.allocations) return null;
      return variant.allocations[String(this.planId)] || null;
    }

    priceFor(variant) {
      if (this.mode === 'subscription') {
        const alloc = this.getAllocation(variant);
        if (alloc) return alloc.price;
      }
      return variant.price;
    }

    /* ---------------- Quantity ---------------- */
    initQuantity() {
      const input = this.querySelector('[data-hk-qty]');
      if (!input) return;
      this.qtyInput = input;
      const step = (delta) => {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        this.render();
      };
      this.querySelector('[data-hk-qty-minus]')?.addEventListener('click', () => step(-1));
      this.querySelector('[data-hk-qty-plus]')?.addEventListener('click', () => step(1));
      input.addEventListener('change', () => {
        if ((parseInt(input.value, 10) || 0) < 1) input.value = 1;
        this.render();
      });
    }

    /* ---------------- Render ---------------- */
    render() {
      const v = this.variant;
      const each = (sel, fn) => this.querySelectorAll(sel).forEach(fn);

      each('[data-hk-variant-card]', (input) => {
        const on = !!v && String(v.id) === input.value;
        input.checked = on;
        input.closest('.hk-qcard')?.classList.toggle('is-selected', on);
      });

      each('[data-hk-each-price]', (el) => {
        const cv = this.variants.find((x) => String(x.id) === el.dataset.variantId);
        if (cv) el.textContent = this.money(Math.round(this.priceFor(cv) / (cv.units || 1)));
      });

      each('[data-hk-po]', (card) => {
        const input = card.querySelector('[data-hk-po-input]');
        card.classList.toggle('is-selected', !!input && input.checked);
      });

      const alloc = this.getAllocation(v);
      const isSub = this.mode === 'subscription' && !!alloc;

      const idInput = this.querySelector('[data-hk-variant-id]');
      if (idInput && v) idInput.value = v.id;
      const planInput = this.querySelector('[data-hk-selling-plan]');
      if (planInput) planInput.value = isSub ? this.planId : '';

      if (!v) {
        this.updateButton(null);
        return;
      }

      const price = isSub ? alloc.price : v.price;
      const compare = isSub ? (alloc.compare_at_price || v.price) : (v.compare_at_price || 0);
      const hasCompare = compare > price;

      each('[data-hk-price]', (el) => { el.textContent = this.money(price); });
      each('[data-hk-compare]', (el) => { el.textContent = this.money(compare); el.hidden = !hasCompare; });
      each('[data-hk-price-badge]', (el) => { el.hidden = !hasCompare; });
      each('[data-hk-percent]', (el) => { el.textContent = hasCompare ? Math.round(((compare - price) * 100) / compare) : 0; });

      if (alloc) {
        const savings = Math.max(0, v.price - alloc.price);
        const pct = v.price ? Math.round((savings * 100) / v.price) : 0;
        each('[data-hk-sub-price]', (el) => { el.textContent = this.money(alloc.price); });
        each('[data-hk-sub-compare]', (el) => { el.textContent = this.money(v.price); el.hidden = savings <= 0; });
        each('[data-hk-sub-badge]', (el) => { el.hidden = pct <= 0; });
        each('[data-hk-sub-percent]', (el) => { el.textContent = pct; });
        each('[data-hk-savings]', (el) => { el.textContent = this.money(savings); });
      }
      each('[data-hk-ot-price]', (el) => { el.textContent = this.money(v.price); });

      this.updateButton(price);
    }

    updateButton(unitPrice) {
      const btn = this.querySelector('[data-hk-atc]');
      if (!btn) return;
      const text = btn.querySelector('[data-hk-atc-text]');
      const v = this.variant;

      if (!v || !v.available) {
        btn.disabled = true;
        if (text) text.textContent = btn.dataset.soldOut || '';
        return;
      }
      btn.disabled = false;
      const qty = Math.max(1, parseInt(this.qtyInput?.value, 10) || 1);
      let label = btn.dataset.label || '';
      if (btn.dataset.showPrice === 'true') {
        const sep = btn.dataset.separator ? `${btn.dataset.separator} ` : '';
        label += ` ${sep}${this.money(unitPrice * qty)}`;
      }
      if (text) text.textContent = label;
    }

    /* ---------------- Add to cart ---------------- */
    initForm() {
      this.form = this.querySelector('form[data-hk-form]');
      if (!this.form) return;
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }

    showError(message) {
      const el = this.querySelector('[data-hk-error]');
      if (!el) return;
      el.textContent = message || '';
      el.hidden = !message;
    }

    async addToCart() {
      const btn = this.querySelector('[data-hk-atc]');
      if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      this.showError('');

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const formData = new FormData(this.form);
      if (!formData.get('selling_plan')) formData.delete('selling_plan');

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      try {
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const data = await res.json();

        if (!res.ok || data.status) {
          const msg = typeof data.description === 'string' ? data.description : data.message;
          this.showError(msg || this.dataset.error);
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'hk-product',
            productVariantId: formData.get('id'),
            cartData: data
          });
        }

        document.dispatchEvent(new CustomEvent('hk:cart-added', { detail: data }));

        if (!cart || typeof cart.renderContents !== 'function') {
          window.location.href = (window.routes && window.routes.cart_url) || `${root}cart`;
          return;
        }
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } catch (err) {
        console.error(err);
        this.showError(this.dataset.error);
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('hk-product', HkProduct);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hk-tab-reviews')) {
    class HkTabReviews extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-hk-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-hk-panel]'));
        this.updaters = [];

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.activate(i));
          tab.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
              e.preventDefault();
              const dir = e.key === 'ArrowRight' ? 1 : -1;
              const next = (i + dir + this.tabs.length) % this.tabs.length;
              this.activate(next);
              this.tabs[next].focus();
            }
          });
        });

        this.panels.forEach((panel) => this.initSlider(panel));

        this.onResize = () => this.updaters.forEach((fn) => fn());
        window.addEventListener('resize', this.onResize);

        this.onBlockSelect = (e) => {
          const i = this.tabs.findIndex((t) => t.dataset.blockId === e.detail.blockId);
          if (i > -1) this.activate(i);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      initSlider(panel) {
        const track = panel.querySelector('[data-hk-track]');
        const prev = panel.querySelector('[data-hk-prev]');
        const next = panel.querySelector('[data-hk-next]');
        if (!track) return;

        const step = () => {
          const card = track.querySelector('.hk-tr__card');
          if (!card) return track.clientWidth;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return card.getBoundingClientRect().width + gap;
        };

        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          panel.classList.toggle('hk-tr--no-overflow', max <= 2);
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max - 2;
        };

        if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

        let ticking = false;
        track.addEventListener(
          'scroll',
          () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
              update();
              ticking = false;
            });
          },
          { passive: true }
        );

        panel.hkUpdate = update;
        this.updaters.push(update);
        update();
      }

      activate(index) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
        });
        this.panels.forEach((panel, i) => {
          const active = i === index;
          panel.classList.toggle('is-active', active);
          if (active) {
            const track = panel.querySelector('[data-hk-track]');
            if (track) track.scrollLeft = 0;
            if (panel.hkUpdate) requestAnimationFrame(panel.hkUpdate);
          }
        });
      }
    }
    customElements.define('hk-tab-reviews', HkTabReviews);
  }

  } catch(e) { console.error(e); }
})();
})();
